<script>
    import FTotalCard from "@/components/FTotalCard";

    export default {
        props: {
            items: {
                type: [Array]
            },
            headers: {
                type: Array
            },
            total: {
                type: Array
            }
        },

        components: {
            FTotalCard
        },

        data() {
            return {
                search: "",
                pagination: {
                    rowsPerPage: 4,
                    totalItems: (this.items && this.items.length) || 0,
                    sortBy: "title"
                },
                open: false
            };
        },

        computed: {
            pages() {
                return Math.ceil(
                    this.pagination.totalItems / this.pagination.rowsPerPage
                );
            }
        },

        watch: {
            items(v) {
                this.pagination.totalItems = v && v.length;
            }
        }
    };
</script>
<template>
    <v-container fluid grid-list-md class='__container'>
        <v-text-field
            v-model='search'
            append-icon='search'
            label='Procurar'
            class='search'
            single-line
            hide-details
        />
        <v-data-iterator
            :items='items'
            :search='search'
            :pagination.sync='pagination'
            content-tag='v-layout'
            hide-actions
            row
            wrap
            no-data-text='Não há items'
            no-results-text='Nenhum item encontrado'
            rows-per-page-text='Items por página'
        >
            <template v-slot:item='props'>
                <v-flex xs12 sm6 md4 lg3>
                    <v-card>
                        <v-card-title style='display: flex; align-items: center; '>
                            <h4 style='flex: 4'>{{ props.item.title }}</h4>
                            <section
                                style='flex: 1; display: flex; align-items: center; justify-content: flex-end'
                            >
                                <v-dialog v-model='open' max-width='600px'>
                                    <template v-slot:activator='{ on }'>
                                        <v-btn flat icon v-on='on' disabled>
                                            <v-icon>remove_red_eye</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text
                                            style='display: flex; justify-content: center; align-items: center'
                                        >
                                            <v-progress-circular
                                                :size='50'
                                                color='primary'
                                                indeterminate
                                            />
                                        </v-card-text>
                                    </v-card>
                                </v-dialog>
                            </section>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-list dense>
                            <v-list-tile v-for='(value, key) in props.item.fields' :key='key'>
                                <v-list-tile-content
                                    style='text-transform: capitalize; font-size: 1rem;'
                                >{{ key }}:</v-list-tile-content>
                                <v-list-tile-content
                                    class='align-end'
                                    style='font-size: 1rem; font-weight: 700'
                                >{{ value }}</v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                    </v-card>
                </v-flex>
            </template>
        </v-data-iterator>

        <FTotalCard v-if="total" :total='total'/>
        <div class='text-xs-center pt-2'>
            <v-pagination v-model='pagination.page' :length='pages'></v-pagination>
        </div>
    </v-container>
</template>

<style>
    .theme--light.application .table {
        border: 1px solid #ccc;
    }
    .theme--dark.application .table {
        border: 1px solid #000;
    }

    .search {
        padding-top: 0;
        margin-top: 10px;
        height: 55px;
    }
    .__container {
        margin-bottom: 5vh;
        padding-top: 0;
        margin-top: 0 !important;
    }
</style>

